import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Articulo } from '../../model/articulo';
import { Consorcio } from '../../model/consorcio';
import { DocumentoSalida } from '../../model/documento-salida';
import { DocumentoDetalleSalida } from '../../model/documento-detalle-salida';

import { ArticuloService } from '../../services/articulo.service';
import { DocumentoDetalleSalidaService } from '../../services/documento-detalle-salida.service';

@Component({
  selector: 'app-documento-salida-detalle-mantenimiento',
  templateUrl: './documento-salida-detalle-mantenimiento.component.html',
  styleUrls: ['./documento-salida-detalle-mantenimiento.component.css']
})
export class DocumentoSalidaDetalleMantenimientoComponent implements OnInit {

  @Input() detalleSeleccionado: DocumentoDetalleSalida;
  @Input() documentoSeleccionado: DocumentoSalida;
  @Output() onReturn = new EventEmitter();

  public consorcio: Consorcio = new Consorcio();
  public _estadoBorrar: boolean = false;
  public _estadoEditar: boolean = false;
  public detalle: DocumentoDetalleSalida = new DocumentoDetalleSalida();
  public codigoCliente: string;

  public articulos: Articulo[];

  constructor(
    private _articuloService: ArticuloService,
    private _documentoDetalleSalidaService: DocumentoDetalleSalidaService
  ) { }

  ngOnInit() {
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.detalle.codigoDocumento = this.documentoSeleccionado.codigoDocumento;
    this.detalle.codigoConsorcio = this.documentoSeleccionado.codigoConsorcio;
    if (this.detalleSeleccionado.id != null) {
      this.detalle = this.detalleSeleccionado;
      this._estadoEditar = true;
    }
    this.consorcio.codigoConsorcio = this.documentoSeleccionado.codigoConsorcio;
    this._articuloService.getArticulos(this.consorcio)
      .subscribe(
      data => this.articulos = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  onSubmit() {
    if (this.detalle.id === undefined) {
      this.detalle.id = 0;
    }
    this._documentoDetalleSalidaService.insert(this.detalle).subscribe(
      result => this.onSubmitSuccess(result),
      err => {
        console.log(err);
      });
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this._estadoBorrar = true;
  }

  solicitudBorrarCancelar() {
    this._estadoBorrar = false;
  }

  borrarRegistro() {
    this._documentoDetalleSalidaService.delete(this.detalle).subscribe(
      result => this.regresar(),
      err => {
        console.log(err);
      });
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/documento-salida-detalle-mantenimiento/documento-salida-detalle-mantenimiento.component.ts